import {
  Box,
  Button,
  Card,
  CircularProgress,
  Grid
} from '@material-ui/core';
import { MaterialUiPickersDate } from '@material-ui/pickers/typings/date';
import React, { FC, memo } from 'react';
import { DatePickerRangeComponent } from 'src/components';
import { dateToday } from 'src/utils';
import SearchIcon from '@material-ui/icons/Search';
import ClearIcon from '@material-ui/icons/Clear';
interface Props {
  dateTo?: string | null;
  dateFrom?: string | null;
  onClear: () => void;
  isFilterLoading: boolean;
  onChangeDate: (date?: MaterialUiPickersDate, field?: string) => void;
  getCustomersByDateRange: () => void;
}

const component: FC<Props> = ({
  dateTo,
  onClear,
  dateFrom,
  onChangeDate,
  isFilterLoading,
  getCustomersByDateRange
}) => {
  return (
    <Card style={{ padding: '2rem' }}>
      {isFilterLoading && (
        <Box
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(255, 255, 255, 0.7)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 5,
            borderRadius: 4 
          }}
        >
          <CircularProgress />
        </Box>
      )}
      <Box
        display="flex"
        flexDirection="row"
        alignItems="center"
        justifyContent="space-evenly"
        style={{ marginBottom: '1em', marginTop: '0' }}
      >
        <DatePickerRangeComponent
          title="Report Date Range"
          fromDateMax={dateToday()}
          fromDateValue={dateFrom}
          toDateValue={dateTo}
          dateToLabel="End Date"
          dateFromLabel="Start Date"
          toDateMin={dateFrom}
          onChangeToDate={(date) => onChangeDate(date, 'to')}
          onChangeFromDate={(date) => onChangeDate(date, 'from')}
        />
      </Box>
      <Grid container spacing={2} justifyContent="center">
        <Grid item xs={6} sm="auto">
          <Button
            endIcon={<ClearIcon />}
            color="secondary"
            onClick={onClear}
            fullWidth
          >
            Clear
          </Button>
        </Grid>
        <Grid item xs={6} sm="auto">
          <Button
            endIcon={<SearchIcon />}
            color="primary"
            variant="contained"
            onClick={getCustomersByDateRange}
            fullWidth
          >
            Apply Filter
          </Button>
        </Grid>
      </Grid>
    </Card>
  );
};

export const TaptapReportToolbar = memo(component);
